import {APP_READY} from './action-types';

export const AppReady = {type: APP_READY};
